export const USER_OBJECT_KEY = 'pokerpattern.user_object';